import { Component, inject, Input, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { CompanyFeatureFlagUI } from 'src/app/domains/feature-flags/models/feature-flags.model';
import { FeatureFlagsService } from 'src/app/domains/feature-flags/services';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { Company, CompanyFlags } from 'voxloud-types/dist/models';

@Component({
  selector: 'gdp-company-feature-flags',
  templateUrl: './company-feature-flags.component.html',
  styleUrls: ['./company-feature-flags.component.scss']
})
export class CompanyFeatureFlagsComponent implements OnInit {
  @Input() company: Company;
  private readonly featureFlagsService = inject(FeatureFlagsService);
  private readonly notificationService = inject(NotificationService);
  public flags: CompanyFeatureFlagUI[] = [];
  public loading: boolean = false;

  ngOnInit(): void {
    this.loadFlags();
  }

  public toggleFlag(flag: CompanyFeatureFlagUI) {
    flag.loading = true;
    const originalValue = flag.value;
    const messageKey = originalValue ? 'companies.confirm-disable-flag' : 'companies.confirm-enable-flag';
    flag.value = !originalValue;

    this.notificationService.showFlagConfirmationWithAlphaname(messageKey, this.company.alphaname, flag.key)
      .then((result: string) => {
        if (result !== 'ok') {
          flag.value = originalValue;
          flag.loading = false;
          return;
        }
        
        const request$ = originalValue
          ? this.featureFlagsService.disableFlagForCompany(flag.id, this.company.companyId)
          : this.featureFlagsService.enableFlagForCompany(flag.id, this.company.companyId);

        request$.pipe(
          finalize(() => flag.loading = false)
        ).subscribe({
          next: () => {},
          error: (err) => {
            flag.value = originalValue;
            flag.loading = false;
          }
        });
      })
      .catch(() => {
        flag.loading = false;
        flag.value = originalValue; 
      });
  }

  private loadFlags() {
    this.loading = true;
    this.featureFlagsService.getCompanyFeatureFlags(this.company.companyId, true).subscribe({
      next: (res: CompanyFlags) => {
        this.flags = res.flags_detail as CompanyFeatureFlagUI[];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    })
  }
}
